var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F07C11"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2705 11.6536C10.3098 12.0633 10.3765 12.3678 10.4683 12.5687C10.5612 12.769 10.7262 12.8689 10.9643 12.8689C11.0089 12.8689 11.0487 12.8619 11.0882 12.8538C11.1286 12.8619 11.1683 12.8689 11.2132 12.8689C11.4506 12.8689 11.6161 12.769 11.7085 12.5687C11.8008 12.3678 11.8663 12.0633 11.9065 11.6536L12.1179 8.49008C12.1573 7.87347 12.1773 7.43105 12.1773 7.16248C12.1773 6.79695 12.082 6.51171 11.8906 6.30693C11.6986 6.10215 11.4464 6 11.134 6C11.1173 6 11.1049 6.00372 11.0885 6.00437C11.073 6.00372 11.0602 6 11.044 6C10.7309 6 10.4792 6.10215 10.2875 6.30693C10.096 6.51204 10 6.79744 10 7.16264C10 7.43121 10.0196 7.87363 10.0596 8.49025L10.2705 11.6536Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0961 14.0254C10.7927 14.0254 10.535 14.1211 10.321 14.3124C10.1072 14.5039 10 14.7364 10 15.0093C10 15.3174 10.1085 15.5599 10.3238 15.736C10.54 15.9121 10.7923 16.0002 11.0806 16.0002C11.3741 16.0002 11.63 15.9134 11.8489 15.7394C12.0674 15.5659 12.1767 15.3221 12.1767 15.0096C12.1767 14.7367 12.0721 14.5042 11.8629 14.3127C11.6538 14.1211 11.3982 14.0254 11.0956 14.0254",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.6cf352dd.svg";
export { ForwardRef as ReactComponent };